﻿import {translation} from "@2d-front-monorepo/core";
import {LinkButton, Markdown} from "@2d-front-monorepo/design-library";
import {JSX} from "react";
import {Navigate} from "react-router";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {getDefaultLandingPage} from "../functions";
import {useUser} from "../hooks/useUser";

import {PublicRoutes} from "../routes";

export default function WelcomePage(): JSX.Element {
	const user = useUser();

	if (user.authStatus == "logged-in") {
		return (<Navigate to={getDefaultLandingPage()}></Navigate>)
	}

	return (
		<section className="welcome full-layout full-layout--centered">
			<h1>{translation(PermitTranslations.welcome_page__title)}</h1>

			<Markdown markdown={translation(PermitTranslations.welcome_page__body)}/>

			<div className="layout vertical gap">
				<LinkButton to={PublicRoutes.signIn} kind="primary">{translation(PermitTranslations.sign_in)}</LinkButton>
				<small style={{textAlign: "center"}}>{translation(PermitTranslations.welcome_page__or)}</small>
				<LinkButton to={PublicRoutes.signUp}>{translation(PermitTranslations.sign_up)}</LinkButton>
			</div>
			<Markdown markdown={translation(PermitTranslations.website__terms_and_conditions)} className="terms-and-conditions"/>
		</section>
	);
}
